import { MouseEventHandler, FC } from 'react'
import * as cn from 'classnames'
import SvgIcon from 'components/atoms/SvgIcon'
import HamburgerSvg from 'icons/hamburger.svg'
import CrossSvg from 'icons/cross.svg'
import * as styles from 'components/features/pfm/MenuButton/MenuButton.css'

export type MenuButtonState = 'hamburger' | 'cross'
type MenuButtonProps = {
  state: MenuButtonState
  onClick: MouseEventHandler<HTMLElement>
}

const MenuButton: FC<MenuButtonProps> = ({ children, state, onClick }) => (
  <div
    className={ cn(styles.hamburger, { [styles.open]: state === 'cross' }) }
    onClick={ onClick }
  >
    <div className={ cn(styles.icon, styles.iconHamburger) }>
      <SvgIcon src={ HamburgerSvg } />
    </div>
    <div className={ cn(styles.icon, styles.iconCross) }>
      <SvgIcon src={ CrossSvg } />
    </div>
    { children }
  </div>
)

export default MenuButton
